/**
 * Mobile Navigation Logic - Accordion Style
 * Handles expandable menu items without slide animations.
 */

document.addEventListener('DOMContentLoaded', function() {
  // Antigravity: Dynamic Header Height Calculation
  function updateHeaderHeight() {
    const header = document.querySelector('.site-header');
    if (header) {
      const rect = header.getBoundingClientRect();
      const bottom = Math.max(0, rect.bottom); 
      document.documentElement.style.setProperty('--header-height', bottom + 'px');
    }
  }
  updateHeaderHeight();
  window.addEventListener('resize', updateHeaderHeight);
  window.addEventListener('scroll', updateHeaderHeight);

  // Monitor body class changes (like js-drawer-open-left) to dynamically recalculate heights
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.attributeName === 'class') {
        updateHeaderHeight();
        setTimeout(updateHeaderHeight, 50);
        setTimeout(updateHeaderHeight, 150);
      }
    });
  });
  observer.observe(document.body, { attributes: true });

  const navContainer = document.querySelector('#NavDrawer');
  if (!navContainer) return;

  // Accordion Toggle Logic
  navContainer.addEventListener('click', function(e) {
    const trigger = e.target.closest('.mobile-nav-trigger');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();

      const targetId = trigger.getAttribute('data-target');
      const accordionContent = navContainer.querySelector(targetId);
      
      if (accordionContent) {
        // Toggle Active State on Trigger
        trigger.classList.toggle('active');
        
        // Toggle Expanded State on Content
        const isExpanding = accordionContent.classList.toggle('is-expanded');
        
        // Update ARIA for accessibility
        trigger.setAttribute('aria-expanded', isExpanding);

        // Optional: Close other accordions at the same level (Exclusive Accordion)
        // If you want only one menu open at a time, uncomment below:
        /*
        const parentUl = trigger.closest('ul');
        if (parentUl) {
           parentUl.querySelectorAll('.mobile-nav-trigger.active').forEach(activeTrigger => {
             if (activeTrigger !== trigger) {
                activeTrigger.classList.remove('active');
                const otherTarget = navContainer.querySelector(activeTrigger.getAttribute('data-target'));
                if (otherTarget) otherTarget.classList.remove('is-expanded');
             }
           });
        }
        */
      }
      return;
    }

    // Handle internal links (ensure they work correctly in accordion)
    const link = e.target.closest('a');
    if (link && !link.classList.contains('mobile-nav-trigger')) {
       // Allow standard link behavior
       return;
    }
  });
});
